import React from "react";
import { Card, Typography, Spin } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined, ShopOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const StatisticCard = ({ title, value, statIcon: StatIcon, loading, className }) => (
  <div key={title} style={{ borderRadius: "8px", overflow: "hidden" }} className="bg-white py-4  px-4">
    {/* <div className="w-full bg-pink-600 h-3 border-t"></div> */}
    <>
      {/* Header Section */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
        <div className="flex flex-col">
          <Text className="text-gray-500 font-medium text-[15px]">
            {title}
          </Text>
          {
            loading ?
              <div className="mt-2"><Spin /></div> :
              <Text className="font-bold text-2xl">
                {Math.floor(value)}
              </Text>}
        </div>
        {StatIcon && <StatIcon className={`${className} stat_icon`} />}
      </div>
      {/* Content Section */}
      <div>

        {/* <Text type="secondary" style={{ fontSize: "12px" }}>
        {stat.changeType === "positive" ? (
          <ArrowUpOutlined style={{ color: "green", marginRight: "4px" }} />
        ) : (
          <ArrowDownOutlined style={{ color: "red", marginRight: "4px" }} />
        )}
        <span style={{ color: stat.changeType === "positive" ? "green" : "red" }}>{stat.change}</span>{" "}
        from last month
      </Text> */}
      </div>
    </>

  </div>
);

export default StatisticCard;
